import { useQueries } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import {
  transfersShippingLogsService,
  type TransfersShippingLogItemViewRow,
} from '@/services/transfers-shipping';

export const useTransfersShippingLogItems = (logIds: string[]) => {
  const queries = useQueries({
    queries: logIds.map((logId) => ({
      queryKey: queryKeys.transfersShipping.logItems(logId),
      queryFn: () => transfersShippingLogsService.getLogItems(logId),
      staleTime: 30_000,
      enabled: Boolean(logId),
    })),
  });

  const itemsByLogId = new Map<string, TransfersShippingLogItemViewRow[]>();
  queries.forEach((query, index) => {
    const logId = logIds[index];
    if (logId && query.data) {
      itemsByLogId.set(logId, query.data);
    }
  });

  const isLoading = queries.some((query) => query.isLoading);
  const isError = queries.some((query) => query.isError);

  return { itemsByLogId, isLoading, isError, queries };
};
